export default {
  'app.pwa.offline': 'Usted está fuera de línea ahora',
  'app.pwa.serviceworker.updated': 'Nuevos contenidos disponibles',
  'app.pwa.serviceworker.updated.hint':
    'Por favor presiona el botón de "Refrescar" para recargar la página actual',
  'app.pwa.serviceworker.updated.ok': 'Refrescar',

  'app.pwa.install.title': 'Instala AUTOMY',
  'app.pwa.install.prompt':
    'Ábrelo como aplicación en este dispositivo y recibe avisos aunque el navegador esté cerrado.',
  'app.pwa.install.button': 'Instalar',
  'app.pwa.install.ios.prompt': 'Instala AUTOMY en tu iPhone para recibir notificaciones',
  'app.pwa.install.ios.chrome.prompt': 'Instala AUTOMY desde Chrome para recibir notificaciones',
  'app.pwa.install.ios.button': 'Cómo instalar',
  'app.pwa.install.ios.step1': 'Toca el botón Compartir',
  'app.pwa.install.ios.chrome.step1': 'Toca Compartir, arriba a la derecha',
  'app.pwa.install.ios.step2': 'Elige Agregar a inicio',
  'app.pwa.install.ios.step3': 'Abre AUTOMY desde el icono nuevo e inicia sesión',
  'app.pwa.install.close': 'Cerrar',

  'app.pwa.offlineBanner.title': 'Sin conexión',
  'app.pwa.offlineBanner':
    'Los formularios abiertos se guardan en este dispositivo y se envían al reconectar.',

  'app.pwa.push.kicker': 'Este dispositivo',
  'app.pwa.push.ask.title': 'Activa las notificaciones',
  'app.pwa.push.ask.message':
    'Te avisamos de tareas asignadas, comentarios y cuando una exportación esté lista, aunque AUTOMY esté cerrado.',
  'app.pwa.push.ask.allow': 'Activar',
  'app.pwa.push.ask.later': 'Ahora no',
  'app.pwa.push.description':
    'Recibe en este dispositivo las tareas asignadas, comentarios y exportaciones listas, aunque AUTOMY esté cerrado.',
  'app.pwa.push.explain':
    'El interruptor aplica solo a este dispositivo. Te avisamos cuando te asignan una tarea, cuando hay un comentario y cuando una exportación está lista.',
  'app.pwa.push.toggle': 'Notificaciones en este dispositivo',
  'app.pwa.push.status.on': 'Activadas en este dispositivo.',
  'app.pwa.push.status.off': 'Desactivadas en este dispositivo.',
  'app.pwa.push.status.unsupported': 'Este navegador no permite notificaciones del sistema.',
  'app.pwa.push.status.iosNeedsInstall':
    'En iPhone y iPad primero instala AUTOMY: Compartir, Agregar a inicio, y ábrelo desde el icono.',
  'app.pwa.push.status.denied':
    'Las notificaciones están bloqueadas. Habilítalas en los permisos del sitio en tu navegador y vuelve a intentarlo.',
  'app.pwa.push.status.unavailable': 'Las notificaciones del dispositivo aún no están disponibles.',
  'app.pwa.push.error': 'No se pudieron cambiar las notificaciones. Inténtalo de nuevo.',
};
